var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFreight2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 322 242",
    enableBackground: "new 0 0 322 242",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 198.5,
    y1: 153.9,
    x2: 198.5,
    y2: 153.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,8.036",
    d: " M206.5,154.7c33.5,3.7,56.5,11.4,56.5,20.2c0,12.5-46.3,22.6-103.5,22.6c-57.1,0-103.5-10.1-103.5-22.6 c0-9.3,25.6-17.3,62.2-20.7"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 122.3,
    y1: 153.7,
    x2: 122.3,
    y2: 153.7
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M181.5,160.4 c17,1.9,28.7,6,28.7,10.7c0,6.6-22.7,11.9-50.6,11.9c-28,0-50.6-5.3-50.6-11.9c0-4.8,12.3-9,30-10.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M199,90.4c-15.4-1.9-30.3-13.5-36.5-18.8 c-1.7-1.5-4.3-1.5-6.1,0c-6.2,5.4-21,16.9-36.5,18.8c-2.5,0.3-4.3,2.4-4.2,4.8c1.9,46.9,32.7,67.5,41.4,72.3 c1.4,0.8,3.1,0.8,4.5,0c8.7-4.9,39.5-25.5,41.4-72.3C203.3,92.8,201.5,90.7,199,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M193.6,94.4c-13.3-1.6-26.1-11.6-31.4-16.3 c-1.5-1.3-3.7-1.3-5.2,0c-5.3,4.6-18.2,14.6-31.4,16.3c-2.1,0.3-3.7,2.1-3.6,4.2c1.6,40.4,28.2,58.2,35.7,62.4 c1.2,0.7,2.7,0.7,3.9,0c7.5-4.2,34.1-22,35.7-62.4C197.3,96.5,195.7,94.7,193.6,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M179.5,119.3c0,11.1-9,20-20,20s-20-9-20-20 c0-11.1,9-20,20-20S179.5,108.3,179.5,119.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "169.8,107.6 155.9,121.4 149.2,114.7  144.4,119.5 151.1,126.2 156,131.1 160.8,126.3 174.7,112.4  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFreight2);
export default __webpack_public_path__ + "static/media/logo-freight-2.ce070f4fa9f48c7a357b62f29d5aac0d.svg";
export { ForwardRef as ReactComponent };